/**
 * Trigger a page view for GTM.
 *
 * @param page THe url of the page.
 * @param event type of GTM event
 * @param additionalParams additional params to be sent to GTM
 * @param {object} additionalParams
 */
const pageview = (
	page: string,
	event = 'pageview',
	additionalParams: { [key: string]: any } = {}
) => {
	window?.dataLayer?.push({ event, page, ...additionalParams });
};

export default pageview;
